import { BarChart3, FileSpreadsheet, FileText } from "lucide-react";
import { ReportTypeOption } from "../services/model/ReportType";

const REPORT_TYPES: ReportTypeOption[] = [
  {
    id: "planned-vs-actuals",
    label: "Planned vs Actuals",
    description: "Rostered vs present, attendance %, per-site daily tiles.",
    audience: "For Operations Managers & Control Room",
    output: "Excel (.xlsx)",
    icon: BarChart3,
  },
  {
    id: "timesheet",
    label: "Timesheet",
    description:
      "Per-shift rows with clock times, one sheet per site plus a summary.",
    audience: "For Payroll Admins",
    output: "Excel (.xlsx)",
    icon: FileSpreadsheet,
  },
  {
    id: "posting-sheet",
    label: "Posting Sheet",
    description:
      "Daily guard roster with P/A/N/A status and replacement tracking.",
    audience: "For Operations Managers & Control Room",
    output: "PDF (.pdf)",
    icon: FileText,
  },
];

export default REPORT_TYPES;
